<template>
	<div class="catcheck">
		<cube-page type="catcheck-view" title="提交订单">
			<div slot="content">
				<div class="ddcheck">
					<!-- 数量选择 -->
					<div class="ddpapge ddcheckitem">
						<div class="ddxq">
							<div class="ddname ells2">
								{{goods.goods_name}}
							</div>
							<LeoCalendar v-if="iscalender" @confirm="confirm" :deData="deDataP" :useDate="beg_Date">
							</LeoCalendar>
						</div>
					</div>
				</div>
				<van-form @submit="onSubmit">
					<div class="ddcheck" style="margin-bottom: 60px;">
						<van-collapse v-model="activeNames" class="ddcheckitem">
							<van-collapse-item title="票务类型" name="1">
								<div class="itembox" v-for="(item,i) in fxlist" :key="i">
									<div class="itemleft">
										{{item.name}}
										<!-- 	<div class="rematk">
										发的反馈给考古发掘看过到付即可观看
									</div> -->
									</div>
									<div class="itemright">
										<van-stepper v-model="item.num" min="0" max="8" @plus="numadd(i)"
											@minus="numre(i)" />
									</div>
								</div>
							</van-collapse-item>
						</van-collapse>
						<div class="ykbox ddcheckitem" v-if="totalnum>0">
							<div class="yktitle" style="padding-top: 0;">
								<div class="title">游客信息</div>
								<div class="rematk" v-if="isOne">
									<span>只须填 1 位</span>,
									其余游客信息无需填写
								</div>
								<div class="rematk" v-else>
									<span>须填 {{totalnum}} 位</span>,
									用于入园身份验证
								</div>
							</div>
							<div class="yklist">
								<span class="ykspan" v-for="(item,index) in ykListData" :key="index">
									<span style="font-size: 14px;">{{'游客'+(index+1)}}</span>
									<van-field label="联系手机" v-model="item.telephone" type="tel" placeholder="用于接收通知短信"
										:rules="[{ required: true, message: '请填写手机号' }]" clearable />
									<van-field label="游客姓名" v-model="item.contacts" placeholder="游客姓名" clearable
										@click-right-icon="show=true"
										:rules="[{ required: true, message: '请填写游客姓名' }]" />
									<van-field label="证件号号" v-model="item.IDCard" placeholder="游客证件号号" clearable
										@click-right-icon="show=true"
										:rules="[{ required: true, message: '请填写证件号号' }]" />
								</span>
							</div>
						</div>
					</div>
					<van-submit-bar :price="totalPrice*100" button-text="提交订单" native-type="submit" :loading="disabled"
						text-align="left" style="box-shadow: 0px -5px 3px #f1f1f1;">
					</van-submit-bar>
				</van-form>
				<cube-view></cube-view>
			</div>
		</cube-page>
	</div>

</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import CubeView from '@/components/TP/cube-view'
	import LeoCalendar from '@/components/TP/leoCalendar'
	import leoAddLk from '@/components/TP/leoAddLk1'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage,
			CubeView,
			LeoCalendar,
			leoAddLk
		},
		data() {
			return {
				activeNames: ['1'],
				activeYks: ['index'],
				disabled: false,
				goods_id: this.$route.query.goods_id,
				goods_num: this.$route.query.goods_num * 1,
				goods_sku_id: this.$route.query.goods_sku_id,
				goods: [],
				//日期插件开始
				selectDate: '', //选中的日期
				beg_Date: '', //起始日期
				deDataP: {
					defaultPrice: '',
					Dates: []
				},
				//日期插件结束
				fxlist: [{
					id: 1,
					name: '成人门票',
					num: 0
				}, {
					id: 2,
					name: '观光车票',
					num: 0
				}, {
					id: 3,
					name: '景区餐票',
					num: 0
				}],
				totalnum: 0,
				tel: '',
				ykListData: [],
				iscalender: false,
				isOne: false,
				totalPrice: 0,
			};
		},
		created() {
			this.distributor = this.$store.getters.getDistributor;
			this.axios_Request();
		},
		methods: {
			onSubmit() {
				let that = this;
				if (that.totalPrice == 0) {
					that.$toast.fail('请选择房型');
					return false;
				}
				if (that.disabled) {
					return false;
				}
				if (that.distributor != null && that.distributor.status != 'normal') {
					Dialog.alert({
						title: '温馨提示',
						message: '请先申请为分销商',
					}).then(() => {
						// 返回首页
						that.$router.push('/My')
						// on close
					});
					return false;
				}
				// use_date 使用时间
				// goods_id 商品ID
				// goods_num 商品数量
				// goods_sku_id
				// visitor 使用人们
				that.disabled = true;
				var url = "/addons/litestore/api.order/submit"
				var param = {
					type: 'gzh',
					use_date: that.selectDate,
					goods_id: that.$route.query.goods_id,
					goods_num: that.goods_num,
					goods_sku_id: that.$route.query.goods_sku_id,
					visitor: that.visitorList
				}
				util.post(url, param,
					function(result) {
						that.disabled = false;
						//return false;
						if (result.code == 1008) {
							//这里不直接跳转了，提示框  为绑定微信，跳转到my页面 绑定微信
							that.$dialog.confirm({
								title: '未通过微信登录',
								message: '您的账号未绑定微信号，请跳转后绑定微信号再进入未支付订单继续支付。'
							}).then(() => {
								that.$router.push({
									path: '/My'
								})
							}).catch(() => {
								that.$router.push({
									name: 'OrderMy',
									params: {
										showType: '0'
									}
								})
							});
						} else {
							// return false;
							//这里发起支付
							console.log('这里能够符合支付条件');
							that.wx_pay_fun(result.data);
						}
					},
					function(result) {
						console.log(result);
					},
					function() {
						that.disabled = false;
					},
				);

			},

			numadd(i) {
				let that = this
				setTimeout(() => {
					that.addYk(true)
				}, 100)
			},
			numre(i) {
				let that = this
				setTimeout(() => {
					that.addYk(false)
				}, 100)
			},
			onJsPrice() {
				let that = this;
				let sdate = that.selectDate;
				let skf = that.fxlist;
				let totalprice = 0;
				skf.forEach((kf) => {
					if (kf.num > 0) {
						totalprice += (sdate.price * 1) * (kf.num * 1);
					}
				});
				that.totalPrice = totalprice
			},
			addYk(isadd) {
				let that = this
				that.totalnum = 0;
				that.fxlist.forEach((item) => {
					that.totalnum += item.num
				})
				console.log(that.isOne)
				if (isadd) {
					that.isOne = true
					if (that.isOne && that.ykListData.length > 0) {
						return;
					}
					let item = {
						contacts: '',
						telephone: '',
						IDCard: ''
					}
					that.ykListData.unshift(item)
				} else {
					that.ykListData.splice(0, 1)
				}
				that.onJsPrice()
			},
			axios_Request() {
				var url = "/addons/litestore/api.order/confirm"
				let that = this;
				let param = {
					goods_id: that.goods_id,
					goods_num: that.goods_num,
					goods_sku_id: that.goods_sku_id,
					use_date: that.use_date
				}
				//这里直接调用网络接口
				util.get(url, param,
					function(result) {
						if (result.data.error_msg) {
							that.$toast.fail(result.data.error_msg);
							return
						}
						if (result.data.player_rule != '10') {
							//只需要填写一个证件号
							that.isOne = true
						}
						that.goods = result.data.goods
						that.goods_sku = result.data.goods.goods_sku
						that.deDataP.defaultPrice = result.data.goods.goods_price
						that.deDataP.Dates = result.data.calendar_price
						that.beg_Date = result.data.advance_time
						that.iscalender = true
						//提示下架的商品
						if (result.data.error_msg) {
							that.$toast.fail(result.data.error_msg);
						}
					},
				);
			},

			// 当日期改变时
			confirm(item) {
				console.log('日历改变时', item)
				this.selectDate = item
			}
		},
		watch: {
			"$store.state.distributor"() {
				this.distributor = this.$store.getters.getDistributor;
			},
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style lang="less">
	.popup-box {
		padding: 15px;
	}

	.itembox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 5px 0;
		color: #000;

		.itemleft {
			flex: 1;

			.rematk {
				padding: 2px 0;
				font-size: 12px;
				color: #868686;
			}
		}

		.itemright {
			width: 100px;
		}
	}

	.itembox+.itembox {
		margin-top: 5px;
		// border-top: 1px solid #e5e5e5;
	}

	.popup-box .titile {
		padding: 5px 0;
		display: flex;
		justify-content: space-between;
	}

	.popup-box .titile span {
		display: block;
		font-size: 18px;
		font-weight: 600;
	}

	.popup-box .titile .an {
		color: #00aaff;
		font-size: 15px;
	}

	.popup-box .items {
		padding: 15px 0;
	}

	.popup-box .items .item {
		display: flex;
		padding: 12px 0;
		font-size: 14px;
	}

	.popup-box .items .item span {
		font-size: 12px;
		color: #959595;
	}

	.popup-box .items .item+.item {
		border-top: 1px solid #dedede;
	}

	.popup-box .items .item .left-title {
		width: 80px;
	}

	.ddcheck {
		width: 96%;
		margin: 0 auto;
		// margin-bottom: 65px;
	}

	.ddcheckitem {
		margin-top: 15px;
		border-radius: 15px;
		overflow: hidden;
		background-color: #FFFFFF;
	}

	.catcheck {
		height: 100%;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: 18;
	}

	.catcheck .cube-page>.wrapper .content {
		margin: 0;
	}

	.catindex .catcheck .card-root-c {
		padding-top: 0px;
		position: relative;
	}

	.catcheck .cube-page>.wrapper {
		background-color: #edeff4;
	}

	.ddname {
		margin: 15px;
		padding-top: 10px;
		font-weight: 600;
	}

	.rqbox {
		padding: 15px;
		/* background-color: #fff8f9; */
	}

	.rqbox .title {
		padding-bottom: 15px;
	}

	.rqbox .title .titlename {
		font-weight: 600;
	}

	.rqbox .title .titletips {
		padding-left: 10px;
		font-size: 13px;
		color: #ff0000;
	}

	.rqbox .title .titletips .van-icon {
		padding-right: 5px;
	}

	.rqlist {
		display: flex;
		justify-content: space-between;

	}

	.rqlist .riitems {
		width: 48px;
		position: relative;
	}

	.rqlist .riitems .tips-top {
		position: absolute;
		top: -10px;
		left: 0;
		font-size: 10px;
		background-color: #ff5500;
		color: #FFFFFF;
		border-top-left-radius: 5px;
		border-bottom-right-radius: 5px;
		padding: 0 2px;
	}

	.rqlist .riitems .itemname {
		display: flex;
		align-items: center;
	}

	.rqlist .riitem {
		padding: 10px 8px;
		border-radius: 8px;
		background-color: #FFFFFF;
		font-size: 14px;
		border: 1px solid #efefef;
	}

	.rqlist .riitem-active {
		background: linear-gradient(to right, #ffaa7f, #ffaa00);
	}

	.rqlist .riitem .itemname span:first-child {
		font-size: 13px;
		padding-right: 3px;
	}

	.rqlist .riitems .itemname div:first-child {
		font-size: 13px;
	}

	.rqlist .riitem .price {
		color: #ff0000;
		font-size: 12px;
	}

	.rqlist .riitem .price span {
		font-size: 15px;
		font-weight: 600;
	}

	.ddxznum {
		padding: 15px;
		background-color: #FFFFFF;
	}

	.ddxznum .ddnum {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.ddxznum .ddnum .leftnum {
		font-size: 16px;
		font-weight: 600;
	}

	.ddxznum .numtip {
		margin: 10px 0;
		padding: 5px;
		border-radius: 2px;
		background-color: #f2f3f5;
		font-size: 13px;
		color: #959595;
	}

	.ykbox {
		padding: 15px;
	}

	.ykbox .yktitle {
		padding: 15px 15px;
		display: flex;
		align-items: center;
	}

	.ykbox .yktitle .title {
		font-size: 16px;
		font-weight: 600;
	}

	.ykbox .yktitle .rematk {
		margin-left: 15px;
		font-size: 12px;
	}

	.ykbox .yktitle .rematk span:first-child {
		color: #ff0000;
	}

	.ykbox .yklist {
		.ykspan {
			width: 100%;
			padding: 5px 0;
			display: block;
			border-bottom: 1px solid #ffaa00;
			border-radius: 5px;
		}

		.ykspan:last-child {
			border: none;
		}
	}

	.ykbox .yklist .ykitem {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding: 10px 15px;
	}

	.ykbox .yklist .ykitem+.ykitem {
		border-top: 1px solid #dedede;
	}

	.ykbox .yklist .ykitem .left {
		display: flex;
		align-items: center;
	}

	.ykbox .yklist .ykitem .left .cleryk {
		text-align: center;
		color: #909090;
	}

	.ykbox .yklist .ykitem .left .cleryk span {
		margin-bottom: 5px;
		display: block;
	}

	.ykbox .yklist .ykitem .left .ykxx {
		padding: 0 15px;
	}

	.ykbox .yklist .ykitem .left .ykxx span {
		color: #00aaff;
	}

	.ykbox .yklist .ykitem .left .ykxx .xxitem {
		padding: 2px 0;
	}

	.right {
		font-size: 13px;
		color: #00aaff;
	}
</style>
